import React, { Component } from 'react'
import StatusPayment from './StatusPayment';
import { formatPrice, formatDate, getPurchasePending } from '../../utils';
import dataLayer from '../../utils/dataLayer';


export default class StatusBoleto extends Component {
    constructor(props){
        super(props);
        this.barCode = React.createRef();

        this.state = {
            textButtonBarcode: 'Copiar código de barras',
            buttonCopyed: false,
        }
    }


    copyBarcode = (e) => {
        dataLayer.genericEvent('sg_event', 'sp_pos_compra', 'click_botao', 'copiar_codigo_de_barras')
        const copyText =  this.barCode.current
        var range = document.createRange();
        range.selectNode(copyText);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        this.setState({textButtonBarcode: 'Código de barras copiado', buttonCopyed: true})
    }

    render() {
        const { purchase } = this.props;
        return (
            <StatusPayment purchase={purchase} theme="Boleto">
                <div className="boleto">
                    <div className="flex-boleto">
                        <div className="infos-payment">
                            <div className="image-boleto">
                                <img
                                    src="/assets/images/icons/boleto.svg"
                                    alt="boleto"
                                />
                            </div>
                            <div className="infos-boleto">
                                <span>{purchase.payment_method}</span> <br />
                                <strong>Total R$ {formatPrice(purchase.price)}</strong>
                            </div>
                        </div>
                        { getPurchasePending(purchase.status) ?
                            purchase.payment.barcode && (
                                <div className="get-boleto">
                                    <a href={purchase.payment.boleto_url} target="_blank" className="ver-boleto">Ver boleto</a>
                                </div>
                            )
                        : purchase.status !== 'Aprovado' || purchase.status !== 'Reprovado' || purchase.status !== 'Cancelado' ? (
                            <div className="get-boleto">
                                O boleto está disponível no seu e-mail.
                            </div>
                        ) : <div />
                        }
                    </div>
                    {purchase.payment.barcode && getPurchasePending(purchase.status) && (
                        <React.Fragment>
                            <div className="barcode-header">
                                <span className="deadline">
                                    Vencimento {formatDate(purchase.payment.deadline)}
                                </span>
                            </div>
                            <div className="barcode-bar" ref={this.barCode}>
                                <span>{purchase.payment.barcode}</span>
                            </div>
                            <div className="barcode-footer">
                                <div className="warning-mail">
                                    O boleto também está disponível no seu e-mail.
                                </div>
                                <div className="copy-barcode">
                                    <button className={this.state.buttonCopyed ? 'active' : ''}  onClick={(e) => this.copyBarcode(e)}>{this.state.textButtonBarcode}</button>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </StatusPayment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/purchase_status/StatusBoleto.jsx